import React from "react";
import { BiInfoCircle } from "react-icons/bi";
import EATooltip from "../EATooltip/EATooltip";
import "./style.scss";

interface IProps {
  title: string;
  description?: string;
  imageUrl?: string;
  tooltipPosition?: "top" | "bottom" | "left" | "right";
}

const GridHeader: React.FC<IProps> = ({ title, description, imageUrl, tooltipPosition = "bottom" }) => {
  const tooltipContent = description ? (
    <div className="grid-header-tooltip">
      {imageUrl && (
        <div className="grid-header-tooltip__image">
          <img src={imageUrl} alt={title} />
        </div>
      )}
      <div className="grid-header-tooltip__description" dangerouslySetInnerHTML={{ __html: description }} />
    </div>
  ) : null;

  return (
    <div className="grid-header">
      <span className="grid-header__title">{title}</span>
      {tooltipContent && (
        <EATooltip content={tooltipContent} position={tooltipPosition}>
          <span className="grid-header__info-icon">
            <BiInfoCircle />
          </span>
        </EATooltip>
      )}
    </div>
  );
};

export default GridHeader;
